import { render, staticRenderFns } from "./PaymentMethodInstance.vue?vue&type=template&id=0cbb0742"
import script from "./PaymentMethodInstance.vue?vue&type=script&lang=js"
export * from "./PaymentMethodInstance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports